import { Divider, Skeleton, Stack } from '@mui/material';

const placeholderRows = [0, 1, 2, 3, 4];

export const CompetitorPricesSkeleton = () => (
  <Stack divider={<Divider flexItem />}>
    {placeholderRows.map((row) => (
      <Stack key={row} direction="row" alignItems="center" gap={2} px={2} py={1.25}>
        <Skeleton variant="circular" width={32} height={32} />
        <Stack flex={1}>
          <Skeleton width={140} />
          <Skeleton width={70} height={16} />
        </Stack>
        <Stack alignItems="flex-end">
          <Skeleton width={100} />
          <Skeleton width={50} height={16} />
        </Stack>
      </Stack>
    ))}
  </Stack>
);
